// Module
var code = `<footer>
    <div class="footer-content">
        <p class="footer-line">
            <span>SPYNE</span>: The behavior-first frontend framework, built on VBL &mdash; View, Behavior, Logic.
        </p>
        <p class="footer-contact">
            Questions or architectural guidance: <a href="mailto:frank@spynejs.com">frank@spynejs.com</a>
        </p>
    </div>
</footer>
`;
// Exports
module.exports = code;